import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import About from "@/pages/about";
import Contact from "@/pages/contact";
import { Home } from "@/pages/home";
import { NotFound } from "@/pages/not-found";
import Projects from "@/pages/projects";

import { Providers } from "./providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
